<template>
	<div class="productBox">
		<div class="banner">
			<p class="txt">即刻开始选择精彩算力产品</p>
			<img src="../../../assets/img/product/icon_3.png" class="icon">
		</div>
		<div class="searchBox flexBox">
			<a-input v-model="serchVal" placeholder="请输入产品名称进行模糊查询" />
			<div class="btn">
				<img src="../../../assets/img/product/icon_2.png" class="icon" @click="clickSearch">
			</div>
		</div>
		<div class="tabList">
			<div class="item flexBox">
				<p class="txt">GPU类型</p>
				<ul class="list flexBox">
					<li v-for="(item,idx) in typeList" :class="typeIdx == idx ? 'active':''" @click="clickType(idx)">
						{{item.name}}
					</li>
				</ul>
			</div>
			<div class="item flexBox">
				<p class="txt">产品类型</p>
				<ul class="list flexBox">
					<li v-for="(item,idx) in brandList" :class="brandIdx == idx ? 'active':''" @click="clickBrand(idx)">
						{{item.name}}
					</li>
				</ul>
			</div>
			<div class="item flexBox">
				<p class="txt" style="word-spacing: 0.2rem;">区　　域</p>
				<ul class="list flexBox">
					<li v-for="(item,idx) in spaceList" :class="spaceIdx == idx ? 'active':''" @click="clickSpace(idx)">
						{{item.name}}
					</li>
				</ul>
			</div>
		</div>
		<ul class="desBox row">
			<li v-for="(item,idx) in goodsList">
				<div class="name">
					{{item.digits}}<span>{{item.name}}</span><span>{{item.hz}}</span><span>{{item.size}}</span>
				</div>
				<div class="box">
					<div class="txt">
						<i class="tag"></i>
						<em>处理器</em><span>{{item.processor}}</span>
					</div>
					<div class="txt">
						<i class="tag"></i>
						内　　存<span>{{item.memory}}</span>
					</div>
					<div class="txt">
						<i class="tag"></i>
						存　　储<span>{{item.storage}}</span>
					</div>
					<div class="txt">
						<i class="tag"></i>
						<em style="letter-spacing: 1.2rem;">GPU</em><span
							style="margin-left: 0;">{{item.gpuTypeName}}*{{item.quantity}}</span>
					</div>
					<div class="val">
						¥<span>{{item.discountPrice}}</span>/{{item.unit}}
					</div>
					<div class="count">
						<span>{{item.originalPrice}}</span>/{{item.unit}}
					</div>
				</div>
				<div class="flexBox">
					<div class="btn" @click="clickGoods(item)">立即购买</div>
					<a-tooltip placement="bottom" class="myTool">
						<template #title>
							<img src="../../../assets/img/lib/icon_1.png" class="icon">
						</template>
						<div class="btn" @click="clickTell(item)">立即咨询</div>
					</a-tooltip>
					
				</div>
			</li>
		</ul>

		<div class="loadBox" v-if="isShow">下滑加载更多</div>
	</div>
</template>

<script>
	export default {
		name: 'Product',
		components: {

		},
		data() {
			return {
				serchVal: null,
				typeList: [],
				typeIdx: 0,
				brandList: [{
					name: 'Nvidia',
					value: 0
				}, {
					name: '华为',
					value: 1
				}],
				brandIdx: 0,
				spaceList: [{
					name: "国产专区1",
					value: 0
				}, {
					name: "国产专区2",
					value: 1
				}, {
					name: "国产专区3",
					value: 2
				}, {
					name: "国产专区4",
					value: 3
				}, {
					name: "国产专区5",
					value: 4
				}, {
					name: "国产专区6",
					value: 5
				}, {
					name: "国产专区7",
					value: 6
				}, {
					name: "国产专区8",
					value: 7
				}],
				spaceIdx: 0,
				goodsList: [],
				pageData: {
					pageNum: 0,
					pageSize: 12,
				},
				isShow: false,
				isLoad: false,
				// 触摸事件相关变量
				startY: 0,
				endY: 0
			}
		},
		mounted() {
			this.getData();
			// 初始化事件监听器
			this.initEventListeners();
		},
		methods: {
			getData() {
				// 获取GPU类型列表
				this.$req("get", "/api/cms/gpuType/list").then((res) => {
					res.data.unshift({
						name: "全部",
						id: null
					});
					this.typeList = res.data;

					// 获取产品类型列表
					this.$req("get", "/api/cms/productType/list").then((product) => {
						product.data.unshift({
							name: "全部",
							id: null
						});
						this.brandList = product.data;

						// 获取区域列表
						this.$req("get", "/api/cms/region/list").then((region) => {
							region.data.unshift({
								name: "全部",
								id: null
							});
							this.spaceList = region.data;
						});

						this.updateList()
					});
				});
			},
			// 初始化事件监听器
			initEventListeners() {
				// 如果已经初始化过，则不再重复初始化
				if (this.touchStartHandler) {
					return;
				}
				
				// 添加滚动事件监听
				window.addEventListener("scroll", this.checkScroll);
				// 添加移动端触摸事件监听
				this.touchStartHandler = (e) => {
					this.startY = e.touches[0].pageY;
				};
				
				this.touchEndHandler = (e) => {
					this.endY = e.changedTouches[0].pageY;
					// 如果是向上滑动且接近底部，则检查是否需要加载更多
					if (this.startY > this.endY) {
						this.checkScroll();
					}
				};
				
				window.addEventListener('touchstart', this.touchStartHandler, { passive: true });
				window.addEventListener('touchend', this.touchEndHandler, { passive: true });
			},
			clickGoods(item) {
				this.$tools.checkLoginAndJump(item.productTypeLink);
			},
			updateList() {
				if (!this.isLoad) {
					this.isLoad = true;
					this.pageData.pageNum++;
					this.getModelList((res) => {
						console.log(res);
						this.$nextTick(() => {
							this.goodsList = this.goodsList.concat(res.rows);
							this.isLoad = false;
							// 判断是否还有更多数据可以加载
							if (this.goodsList.length < res.total) {
								// 还有更多数据
								if (!this.isShow) {
									this.isShow = true;
									this.scroll()
								}
							} else {
								// 没有更多数据了
								if (this.isShow) {
									this.isShow = false;
									this.resetScroll();
								}
							}
						})
					})
				}
			},
			getModelList(call) {
				this.$req("get", "/api/cms/product/list", {
					params: {
						name: this.serchVal,
						productTypeId: this.brandList[this.brandIdx].id,
						gpuTypeId: this.typeList[this.typeIdx].id,
						regionId: this.spaceList[this.spaceIdx].id,
						pageNum: this.pageData.pageNum,
						pageSize: this.pageData.pageSize,
					}
				}).then((res) => {
					call(res)
				});
			},
			scroll() {
				// 确保事件监听器已添加
				this.initEventListeners();
			},
			checkScroll() {
				// 如果已经在加载，则不继续加载
				if (this.isLoad) {
					return;
				}
				
				// 如果已经没有更多数据了，则不继续加载
				if (!this.isShow) {
					return;
				}
				
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				let windowHeight = window.innerHeight;
				let documentHeight = document.documentElement.scrollHeight;
				
				// 添加一个缓冲区，确保在接近底部时就能触发加载
				if (scrollTop + windowHeight >= documentHeight - 100) {
				    this.updateList()
				}
			},
			resetScroll() {
				// 移除事件监听器
				window.removeEventListener("scroll", this.checkScroll);
				if (this.touchStartHandler) {
					window.removeEventListener('touchstart', this.touchStartHandler);
				}
				if (this.touchEndHandler) {
					window.removeEventListener('touchend', this.touchEndHandler);
				}
			},
			resetPage() {
				this.isShow = false;
				this.isLoad = false;
				this.pageData.pageNum = 0;
				this.pageData.pageSize = 12;
			},
			clickSearch() {
				this.goodsList = [];
				this.resetScroll();
				this.resetPage();
				// 重新初始化事件监听器
				this.initEventListeners();
				this.updateList();
			},
			clickType(idx) {
				this.typeIdx = idx;
				this.clickSearch()
			},
			clickBrand(idx) {
				this.brandIdx = idx;
				this.clickSearch()
			},
			clickSpace(idx) {
				this.spaceIdx = idx;
				this.clickSearch()
			},
			clickTell(res) {
				console.log(res);
			}
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/product.css");
</style>